import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { bemGenerator } from '@prisjakt/ui-base';
import ArrowIcon from 'mdi-react/ChevronRightIcon';
import './breadcrumb.scss';

const styles = bemGenerator('legacy-breadcrumb', [
  'env-desktop',
  'env-mobile',
  'home',
  'path',
  'divider',
]);

const renderItems = items =>
  items.map((p, index) => (
    <div key={p.name} className={index === 0 ? styles.home : styles.path}>
      {index !== 0 ? (
        <span className={styles.divider}>
          <ArrowIcon color="#707070" />
        </span>
      ) : null}
      {p.pathName && index < items.length - 1 ? (
        <Link
          to={p.pathName}
          onClick={e => {
            if (p.externalLink) {
              e.preventDefault();
              window.location.href = e.currentTarget.href;
            }
          }}
        >
          {p.name}
        </Link>
      ) : (
        <span>{p.name}</span>
      )}
    </div>
  ));

const LegacyBreadcrumb = ({ path, homeText }) => {
  const pathWithHome = [
    {
      name: homeText,
      pathName: '/',
      externalLink: true,
    },
  ].concat(path);

  const mobilePath = [
    {
      name: <ArrowIcon left height={6} styling="neutral-light" />,
      pathName: path.length > 1 ? path[path.length - 2].pathName : '/',
      externalLink: !(path.length > 1),
    },
  ].concat(
    !path.length ? pathWithHome.concat({ name: null }) : pathWithHome.slice(-2)
  );

  return (
    <div className={styles.block}>
      <div className={styles['env-desktop']}>{renderItems(pathWithHome)}</div>
      <div className={styles['env-mobile']}>{renderItems(mobilePath)}</div>
    </div>
  );
};

const { string, shape, arrayOf } = PropTypes;

LegacyBreadcrumb.propTypes = {
  homeText: string.isRequired,
  path: arrayOf(
    shape({
      name: string.isRequired,
      pathName: string,
    })
  ),
};

LegacyBreadcrumb.defaultProps = {
  path: [],
};

export default LegacyBreadcrumb;
